<template>
  <!-- 介绍详情内容 -->
  <div class="content-html">
    <h4 class="text-color">{{ aboutUs.title }}</h4>
    <p :class="local === 'zh' ? 'content-text content-html-img content-html-img-zh' : 'content-text content-html-img content-html-img-en'" v-html="aboutUs.content"></p>
  </div>
</template>

<script>
import { centerDetai } from "../../../api/aboutUs";
export default {
  name: "DetaiIndex",
  data() {
    return {
      // aboutUs: this.$t("aboutUs"),
      aboutUs: "",
      local: localStorage.getItem("languageSet") || "zh",
    };
  },
  created() {
    this.centerDetaiApi();
  },
  methods: {
    centerDetaiApi() {
      centerDetai().then((res) => {
        this.aboutUs = res || {};
      });
    },
  },
};
</script>

<style></style>
